/** Tipos de evento que muestra la Agenda. */
export type AgendaKind = 'FOLIO' | 'REMISION' | 'INCIDENCIA' | 'DLV';

export interface AgendaKindMeta {
  kind: AgendaKind;
  label: string;      // plural (indicadores, leyenda)
  singular: string;
  icon: string;
  color: string;
  route: string;      // pantalla del módulo
}

export const AGENDA_KINDS: AgendaKindMeta[] = [
  { kind: 'FOLIO',      label: 'Folios',             singular: 'Folio',             icon: 'assignment',         color: '#1010eb', route: '/interventions/folios' },
  { kind: 'REMISION',   label: 'Remisiones',         singular: 'Remisión',          icon: 'receipt_long',       color: '#7b1fa2', route: '/interventions/remissions' },
  { kind: 'INCIDENCIA', label: 'Incidencias',        singular: 'Incidencia',        icon: 'report_problem',     color: '#d32f2f', route: '/incidents' },
  { kind: 'DLV',        label: 'Entregas de delivery', singular: 'Entrega de delivery', icon: 'local_shipping', color: '#14853d', route: '/materialReception' },
];

export const AGENDA_KIND: Record<AgendaKind, AgendaKindMeta> =
  Object.fromEntries(AGENDA_KINDS.map(k => [k.kind, k])) as Record<AgendaKind, AgendaKindMeta>;

export interface AgendaEvent {
  id: string;
  kind: AgendaKind;
  date: Date;
  /** ¿La hora es real? (los registros con solo fecha no muestran hora). */
  hasTime: boolean;
  title: string;        // folio / número
  subtitle: string;     // paciente · procedimiento, pieza, DLV…
  place: string;        // hospital
  status: string;
  /** Renglones "Etiqueta: valor" para el detalle. */
  details: { label: string; value: string }[];
  /** Ruta para abrir el registro (o la pantalla del módulo). */
  link: any[];
  search: string;
}
